import React from "react";
import "../../../styles/ToDoList.css";
import { withNamespaces } from 'react-i18next'; 

const Chegada = ({t}) => {
  return (
    <>
      <div className="col-12 col-lg">
        <div id="2" className="fantasmaAncora"></div>
        <div className="card">
          <div id="chegada" className="card-body">
            {/* superior */}

            <div className="info">
              <h4 className="title">{t('moduleToDoList:S2.T')}</h4>
            </div>

            {/* inferior */}

            <ul>
              <hr className="divider"></hr>
              <li>
                
                <a href="/chegadaAveiro#3" className="right mx-auto">
                  <p className="mt-1">{t('moduleToDoList:S2.UL.LI1')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a href="/chegadaAveiro#2" className="right mx-auto">
                  <p className="mt-1">{t('moduleToDoList:S2.UL.LI2')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="/chegadaAveiro#comprovativo_morada"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S2.UL.LI3')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a href="/chegadaAveiro#nif" className="right mx-auto">
                  <p className="mt-1">{t('moduleToDoList:S2.UL.LI4')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="/chegadaAveiro#turmas_horarios"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S2.UL.LI5')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="/chegadaAveiro#abertura_conta"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S2.UL.LI6')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="/chegadaAveiro#cartao_estudante"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S2.UL.LI7')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="/chegadaAveiro#inscricao_sns"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S2.UL.LI8')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
export default withNamespaces() (Chegada);
